"use client";

import { FileText } from "lucide-react";
import { Markdown } from "@/components/markdown";

interface SummaryViewProps {
  summary: string;
}

export function SummaryView({ summary }: SummaryViewProps) {
  if (!summary) {
    return (
      <div className="flex flex-col items-center justify-center h-full py-12 text-muted-foreground">
        <FileText className="h-12 w-12 mx-auto mb-4 opacity-50" />
        <p>No summary available for this workflow.</p>
      </div>
    );
  }

  // Clean kramdown syntax like {: .img-responsive}
  const cleanedSummary = summary.replace(/\{:[^}]+\}/g, '');

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="flex-1 overflow-y-auto p-6">
        <div className="max-w-4xl mx-auto prose prose-sm dark:prose-invert">
          <Markdown enableCellCitations citationWorkflowView="current-run">
            {cleanedSummary}
          </Markdown>
        </div>
      </div>
    </div>
  );
}
